export const ADJUSTMENTS_REASONS_FETCH = 'ADJUSTMENTS_REASONS_FETCH';
export const ADJUSTMENTS_REASONS_FETCH_ALL = 'ADJUSTMENTS_REASONS_FETCH_ALL';
export const ADJUSTMENTS_REASONS_IS_FETCING = 'ADJUSTMENTS_REASONS_IS_FETCING';
export const ADJUSTMENTS_REASONS_API = 'adjustments/reasons';
export const ADJUSTMENT_REASONS_EDIT = 'ADJUSTMENT_REASONS_EDIT';
export const ADJUSTMENT_REASONS_SAVE = 'ADJUSTMENT_REASONS_SAVE';
export const ADJUSTMENT_REASONS_FILTER = 'ADJUSTMENT_REASONS_FILTER';
export const UPDATE_ADJUSTMENT_REASONS_STATUS = 'UPDATE_ADJUSTMENT_REASONS_STATUS';



// WEBPACK FOOTER //
// ./src/constants/adjustmentsReasons.js